export default __webpack_public_path__ + "static/artistBox-mono-monet-46c683ed84e9366001cbbd44a74c234c.png";